export enum ProcedureCodes {
  PAYMENT_DEFERMENT = '300000015',
  INVOICE_CONCEPT = '300000004',
  PORTUGAL_INVOICE_CONCEPT = '400000004',
  CANCELLATION = '300000009',
  PORTUGAL_CANCELLATION = '400000009',
  PORTUGAL_CYCLE_CHANGE = '400000021',
  POWER_TARIFF_CHANGE = '300000013',
  PORTUGAL_POWER_CHANGE = '400000013',
  ACCOUNT_CHANGE = '300000007',
  PORTUGAL_ACCOUNT_CHANGE = '400000007',
  INVOICE_ADDRESS_CHANGE = '300000008',
  PORTUGAL_CHANGE_BILLING_CONTACTS = '400000008',
  CONCEPTS_DISCREPANCY = '300000001',
  POWER_DISCREPANCY = '300000002',
  PORTUGAL_POWER_DISCREPANCY = '400000002',
  MEASUREMENT_DISCREPANCY = '300000003',
  INVOICE_DELAY = '300000017',
  PORTUGAL_INVOICE_DELAY = '400000017',
  OUTAGES_FAILURES = '300000016',
  PORTUGAL_OUTAGES_FAILURES = '400000016',
  MEASUREMENT_FILE_INCIDENCE = '300000020',
  PORTUGAL_MEASUREMENT_FILE_INCIDENCE = '400000020',
  SELF_CONSUMPTION_CHANGE = '300000019',
  HOLDER_CHANGE = '300000011',
  HOLDER_CHANGE_SURROGATE = '300000012',
  PORTUGAL_HOLDER_CHANGE = '400000012',
  PORTUGAL_METER_READING = '400000022',
}
